export const removeImageFormat = (imageName: string) => {
	return imageName.replace('_bg_removed.png', '').replace('.jpg', '').replace('.png', '');
};
